import React from "react";
import { Badge, Tooltip } from "@chakra-ui/react";

// Longest schema name shown in full; anything longer is abbreviated.
export const SCHEMA_BADGE_MAX = 8;

// "SOC_WORK" stays as it is. Longer names become their initials —
// "north_valley_clinic" and "NorthValleyClinic" → "NVC", "clinic_12" → "C12" —
// or, when they're one long word, a clipped "pallick…".
export function abbreviateSchema(name, max = SCHEMA_BADGE_MAX) {
  const full = String(name || "").trim();
  if (full.length <= max) return full;
  const words = full
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Za-z])(\d)/g, "$1 $2")
    .replace(/(\d)([A-Za-z])/g, "$1 $2")
    .split(/[^A-Za-z0-9]+/)
    .filter(Boolean);
  if (words.length > 1) {
    const initials = words.map((w) => (/^\d+$/.test(w) ? w : w[0].toUpperCase())).join("");
    if (initials.length <= max) return initials;
  }
  return `${full.slice(0, max - 1)}…`;
}

// The schema a colleague is working in, as a small pill; hovering shows the
// full name. Same indigo as the schema chip on chart rows (RowOriginBadge).
export default function SchemaBadge({ schema, ...rest }) {
  const full = String(schema || "").trim();
  if (!full) return null;
  return (
    <Tooltip label={full} hasArrow openDelay={150}>
      <Badge
        data-testid="schema-badge"
        textTransform="none"
        fontSize="10px"
        fontWeight="semibold"
        lineHeight="16px"
        px={1.5}
        borderRadius="sm"
        bg="#e0e7ff"
        color="#4338ca"
        flexShrink={0}
        cursor="default"
        {...rest}
      >
        {abbreviateSchema(full)}
      </Badge>
    </Tooltip>
  );
}
